import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useBenchmark = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);

    const onGetBenchmarkError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while retrieving performance benchmark.',
        );
    };

    const onGetBenchmarkSuccess = (callbackFn: () => void) => ({ data, message }: SuccessHttpResponse<any>) => {
        toast.success(message ?? 'Performance benchmark retrieved successfully.');
        callbackFn();
    };

    const setBenchmark = (data: any, callbackFn: () => void) => {
        const url: HttpConfig = {
            url: `ba/v1/configs/set-baseline-percent`,
            method: 'post',
            data: { baseline: data.benchmark },
        };

        // const url: HttpConfig = {
        //     url: `ba/v1/demo-requests/export`,
        //     method: 'get',
        // };
        request(url, onGetBenchmarkSuccess(callbackFn), setLoading, onGetBenchmarkError);
    };

    return { setBenchmark, loading };
};

export default useBenchmark;
